module.exports = __webpack_public_path__ + "static/img/1699.d8e1dce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-mini/1699.png
// module id = +Jc9
// module chunks = 12